import type { SubscriptionStepId } from '@orus.eu/dimensions'

import type { StandaloneFormRedirect } from './standalone-form-access.types.ts'

import {
  pickPropagatedSearchParams,
  SUBSCRIPTION_FUNNEL_PROPAGATED_KEYS,
} from '#/lib/subscription-injectable-params.ts'
import type { SearchParams } from '#/routes/__root.tsx'

type StandaloneFormRedirectOptions =
  | {
      to: '/subscribe/$subscriptionId/$stepId'
      params: { subscriptionId: string; stepId: SubscriptionStepId }
      search: (previous: SearchParams) => Partial<SearchParams>
      replace: true
    }
  | { to: '/'; replace: true }

/** The navigation options that send a customer away from a standalone form, for `redirect` and `Navigate` alike. */
export function standaloneFormRedirectOptions(
  redirect: StandaloneFormRedirect,
  subscriptionId: string,
): StandaloneFormRedirectOptions {
  switch (redirect.to) {
    case 'funnel':
      return {
        to: '/subscribe/$subscriptionId/$stepId',
        params: { subscriptionId, stepId: redirect.stepId },
        search: (previous) => pickPropagatedSearchParams(previous, SUBSCRIPTION_FUNNEL_PROPAGATED_KEYS),
        replace: true,
      }
    case 'customer-portal':
      return { to: '/', replace: true }
  }
}
